// 顧客新規作成画面
import React, { useState, useEffect, useCallback } from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  Grid,
  Theme,
  Divider,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  Tooltip
} from '@material-ui/core';
import { withStyles, makeStyles, createStyles } from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import NumberInput from '../components/NumberInput';
import DeleteIcon from '@material-ui/icons/Delete';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import MailIcon from '@material-ui/icons/Mail';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import './List.css';
import { useHistory, Redirect, useLocation } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { getCustomerType } from '../apicalls/getCustomerTypes';
import {
  mainBlueColor,
  btnColor,
  isLoggedIn,
  furiganaRegex,
  invalidPhoneNumberRegex,
  assignedTypesRecoilData,
  userMenuId,
  userTenant
} from '../GlobalState';
import { getCustomerConstruction } from '../apicalls/getCustomerDetails';
import { getEmployeeMasterList } from '../apicalls/employeeMaster';

import {
  getPrefecture,
  getMediation,
  getIndustries,
  getEndOfDay,
  getRank,
  saveCustomer,
  getCustomerDetails,
  editCustomer,
  saveContactUs,
  getContactUsHistory,
  deleteContactUsHistory,
  deleteCustomerById,
  sendMail,
  fetchAddressFromPostalCode
} from '../apicalls/createCustomer';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import LoadingComponent from '../components/LoadingComponent';
import { getEmployeeGroups } from '../apicalls/employeeGroup';
import { parsePrice } from '../utils';
import { DateField } from '../components/molecules';
import { formatDatetime } from '../utils/common';
import { BasicSelect } from '../components/parts/input/BasicSelect';
import { TTopicPathState } from '../components/topicPath/type/Type';
import { ExtInfoBoxes } from '../components/extInfoBox/ExtInfoBoxes';
import { TInfoBox } from '../types/ExtInfoBox';
import { getExtInfoBoxes } from '../apicalls/extInfoBox';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { NoteAdd } from '@material-ui/icons';
import HelpIcon from '@material-ui/icons/Help';
import { getUserSelectOptions } from '../utils/processAndTaskFormUtils';
import {
  CUSTOMER_SPECIFIC_INVOICE_AVAILABLE_TENANT_IDS,
  EXT_INFO_SCREEN_TYPE
} from '../const/Const';
import { TTenant } from '../types/common';
import { StaffData } from '../types/staffData';
import { getStaffSelectOptions } from '../utils/getStaffSelectOptions';

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white
    },
    body: {
      fontSize: 16
    }
  })
)(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

const ContactHistoryTableRow: React.FC<{
  row: any;
  employeeGroups: any;
  handleContactHistoryDeleteButtonClick: any;
  sendMailToGroup: any;
}> = ({
  row,
  employeeGroups,
  handleContactHistoryDeleteButtonClick,
  sendMailToGroup
}) => {
  const [employeeGroupId, setEmployeeGroupId] = useState<number | null>(null);
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      tooltip: {
        fontSize: 14
      }
    })
  );
  const classes = useStyles();

  return (
    <StyledTableRow key={row.id}>
      <StyledTableCell align='center' component='th' scope='row'>
        {row.desired_date_of_delivery}
      </StyledTableCell>
      <StyledTableCell align='center'>{row.property}</StyledTableCell>
      <StyledTableCell align='center'>{row.location}</StyledTableCell>
      <StyledTableCell align='right'>
        {parsePrice(row.budget, '')}
      </StyledTableCell>
      <StyledTableCell align='center'>{row.content}</StyledTableCell>
      <StyledTableCell align='center'>
        {row.desired_real_estate_content}
      </StyledTableCell>
      <StyledTableCell align='center'>
        <FormControl className={classes.formControl}>
          <BasicSelect
            style={{ width: 160, paddingLeft: 10 }}
            disabled={row.email_sent === true ? true : false}
            value={row.group_id > 0 ? row.group_id : employeeGroupId}
            onChange={e => {
              setEmployeeGroupId(parseInt(e.target.value));
            }}
            disableUnderline
          >
            <option>選択してください</option>
            {employeeGroups.map((i: any) => (
              <option value={i.id}>{i.name}</option>
            ))}
          </BasicSelect>
        </FormControl>
      </StyledTableCell>
      <StyledTableCell>
        <Button
          style={{
            color: '#758283',
            backgroundColor: '#F5F5F5',
            width: 100
          }}
          variant='contained'
          color='secondary'
          onClick={() => {
            handleContactHistoryDeleteButtonClick(row.id);
          }}
          startIcon={<DeleteIcon />}
        >
          削除
        </Button>
      </StyledTableCell>
      <StyledTableCell>
        <CustomTooltip title='' placement='top'>
          <Button
            style={{
              color: '#758283',
              backgroundColor: row.email_sent === true ? '#c1c1c1' : '#F5F5F5',
              width: 120
            }}
            variant='contained'
            color='secondary'
            disabled={row.email_sent === true || employeeGroupId ? false : true}
            onClick={() => {
              sendMailToGroup(row.id, employeeGroupId);
            }}
          >
            メール送信
          </Button>
        </CustomTooltip>
        <CustomTooltip
          title={tooltipContents.customerListSendMail}
          placement='right'
        >
          <HelpIcon color='action' style={{ margin: 8 }} />
        </CustomTooltip>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export const CreateCustomer: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [isFurigana] = useRecoilState(furiganaRegex);
  // 選択タブ番号(1:工事情報、2:書類情報、3:現場情報、4:追加情報)
  const [selectTab, setSelectTab] = useState<number>(1);

  const isMobile = window.innerWidth < 500;

  //顧客別請求書を限定公開する企業の判別
  const userTenantData = useRecoilValue<TTenant | undefined>(userTenant);
  const mode = process.env
    .REACT_APP_MODE as keyof typeof CUSTOMER_SPECIFIC_INVOICE_AVAILABLE_TENANT_IDS;
  const customerSpecificTenantIds =
    CUSTOMER_SPECIFIC_INVOICE_AVAILABLE_TENANT_IDS[mode];
  const isCustomerSpecificInvoiceAvailable = userTenantData
    ? customerSpecificTenantIds.includes(userTenantData.id)
    : false;

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontSize: 16
      },
      table1: {
        minWidth: 700
      },
      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 60,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input: {
        minHeight: 40,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },

      inputMainContainer1: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 120,
        alignItems: 'center',
        width: '100%'
      },
      textMainContainer1: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 120,
        alignItems: 'center'
      },
      textContainer1: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input1: {
        minHeight: 100,
        maxHeight: 200,
        width: '100%'
      },
      textMainContainer2: {
        display: 'flex',
        backgroundColor: mainColor,
        minHeight: 120,
        alignItems: 'center'
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      formControl1: {
        minWidth: 120,
        height: 30,
        borderRadius: 5,
        borderWidth: 1,
        paddingLeft: 5
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        minHeight: 48,
        width: '100%'
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      },
      topContainer: {
        display: 'flex',
        paddingBottom: 15,
        justifyContent: 'space-between'
      },
      topList: {
        display: 'flex',
        marginTop: 25,
        marginBottom: 25,
        width: '100%',
        justifyContent: 'flex-start'
      },
      topColumn: {
        fontSize: 16,
        color: '#000000'
      }
    })
  );

  const classes = useStyles();
  const history: any = useHistory();
  const location: any = useLocation();
  const matches2 = useMediaQuery('(min-width:900px)');
  const [assignedTypesApiData, setAssignedTypesApiData] = useRecoilState(
    assignedTypesRecoilData
  );
  const [assignedTypes, setAssignedTypes] = useState<any>(
    assignedTypesApiData !== null ? assignedTypesApiData : []
  );
  const changeAssignedTypesApiData = useCallback(
    (newData: any) => setAssignedTypesApiData(newData),
    [setAssignedTypesApiData]
  );
  const [flag, setFlag] = useState('');

  const [customerConstructionData, setCustomerConstructionData] = useState([]);

  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const [prefecture, setPrefecture] = useState([]);
  const [mediations, setMediations] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [endOfDay, setEndOfDay] = useState([]);
  const [rank, setRank] = useState([]);
  const [insideEmployees, setInsideEmployees] = useState([]);
  const [selectedCustomerType, setSelectedCustomerType] = useState<number>();

  const [customerName, setCustomerName] = useState('');
  const [furigana, setFurigana] = useState('');
  const [postalCode, setPostalCode] = useState<string>('');
  const [selectedPrefecture, setSelectedPrefecture] = useState<number>();
  const [municipality, setMunicipality] = useState('');
  const [address, setAddress] = useState('');
  const [buildingName, setBuildingName] = useState('');
  const [tel, setTel] = useState<any>('');
  const [fax, setFax] = useState<any>('');
  const [chargeName, setChargeName] = useState('');
  const [chargeTel, setChargeTel] = useState<string>('');
  const [chargeEmail, setChargeEmail] = useState<string>('');
  const [charge1, setCharge1] = useState<number>(0);
  const [charge2, setCharge2] = useState<number>(0);
  const [charge1Data, setCharge1Data] = useState<StaffData | null>(null);
  const [charge2Data, setCharge2Data] = useState<StaffData | null>(null);
  const [selectedHousing, setSelectedHousing] = useState<number>();
  const [selectedMediation, setSelectedMediation] = useState<number>();
  const [selectedIndustry, setSelectedIndustry] = useState<number>();
  const [selectedEndOfDay, setSelectedEndOfDay] = useState<number>();
  const [selectedDepositeSiteMonth, setSelectedDepositeSiteMonth] =
    useState('');
  const [selectedDepositeSiteDate, setSelectedDepositeSiteDate] = useState('');
  const [selectedRank, setSelectedRank] = useState<number>();
  const [remarks, setRemarks] = useState('');

  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedDateValue, setSelectedDateValue] = useState('');

  const [property, setProperty] = useState<string>('');
  const [place, setPlace] = useState<string>('');
  const [budget, setBudget] = useState<number>(0);
  const [content, setContent] = useState<string>('');
  const [realEstateRequest, setRealEstateRequest] = useState<string>('');

  const [contactHistory, setContactHistory] = useState([]);
  const [selectedContactUsHistoryId, setSelectedContactUsHistoryId] =
    useState<number>(0);

  const [loading, setLoading] = useState(true);
  const [employeeGroups, setEmployeeGroups] = useState<any>([]);

  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );
  const [userMenu] = useRecoilState(userMenuId);
  const [defaultValues, setDefaultValues] = useState<TInfoBox[]>([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    if (!history.location.state.state) {
      return;
    }
    getExtInfoBoxes(history.location.state?.state, 1).then((data: any) => {
      if (data.data === 'Not logged in!') {
        setOpen(true);
        setErrorMessage(data.data);
      } else {
        if (typeof data.data === 'string') {
          setOpen(true);
          setErrorMessage(data.data);
        } else {
          setDefaultValues(data.data);
        }
      }
    });
  };

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  const getInsideEmployees = useCallback(() => {
    getEmployeeMasterList('', 0, 0, 1).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setInsideEmployees(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getAllPrefectures = useCallback(() => {
    getPrefecture().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setLoading(false);
            setPrefecture(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getAllMediation = useCallback(() => {
    getMediation().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setLoading(false);
            setMediations(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getAllIndustries = useCallback(() => {
    getIndustries().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setIndustries(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getAllEndOfDay = useCallback(() => {
    getEndOfDay().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setEndOfDay(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getAllRanks = useCallback(() => {
    getRank().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setRank(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getAllCustomerConstructionDetails = useCallback(() => {
    if (!history.location.state.state) {
      return;
    }
    getCustomerConstruction(history.location.state.state).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setCustomerConstructionData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData, history.location.state]);

  const saveCustomerDetails = () => {
    setErrorMessage('');
    if (customerName.trim() === '') {
      setErrorMessage('顧客名を入力してください。');
      setOpen(true);
    } else if (customerName.length > 30) {
      setErrorMessage('会社名は30文字以内で入力してください。');
      setOpen(true);
    } else if (furigana.trim() === '') {
      setErrorMessage('ふりがなを入力してください。');
      setOpen(true);
    } else if (!isFurigana.test(furigana.trim())) {
      setErrorMessage('無効なふりがなです。');
      setOpen(true);
    } else if (tel.trim() !== '' && tel.trim().length > 60) {
      setErrorMessage('無効なTELです。');
      setOpen(true);
    } else if (chargeTel.trim() !== '' && chargeTel.trim().length > 60) {
      setErrorMessage('無効な顧客側担当者電話番号です。');
      setOpen(true);
    } else if (
      (selectedDepositeSiteMonth === '' && selectedDepositeSiteDate !== '') ||
      (selectedDepositeSiteMonth !== '' && selectedDepositeSiteDate === '')
    ) {
      setErrorMessage('入金サイト 月を 日付を 必須');
      setOpen(true);
    } else {
      saveCustomer(
        customerName.trim(),
        furigana.trim(),
        postalCode.trim(),
        selectedCustomerType,
        selectedPrefecture,
        municipality.trim(),
        address.trim(),
        buildingName.trim(),
        tel.trim(),
        fax.trim(),
        chargeName.trim(),
        chargeTel.trim(),
        chargeEmail.trim(),
        charge1,
        charge2,
        selectedHousing,
        selectedMediation,
        selectedIndustry,
        selectedEndOfDay,
        selectedDepositeSiteMonth,
        selectedDepositeSiteDate,
        selectedRank,
        remarks.trim()
      ).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setSuccessMessage(data.message);
              setOpenSuccess(true);
              setTimeout(() => {
                history.push(`/customers/${data.new_customer_id}/edit`, {
                  state: data.new_customer_id
                });
              }, 2000);
            }
          }
        }
      });
    }
  };

  const editCustomerDetails = () => {
    setErrorMessage('');
    if (customerName.trim() === '') {
      setErrorMessage('顧客名を入力してください。');
      setOpen(true);
    } else if (customerName.length > 30) {
      setErrorMessage('顧客名は30文字以内で入力してください。');
      setOpen(true);
    } else if (furigana.trim() === '') {
      setErrorMessage('ふりがなを入力してください。');
      setOpen(true);
    } else if (!isFurigana.test(furigana.trim())) {
      setErrorMessage('無効なふりがなです。');
      setOpen(true);
    } else if (tel.trim() !== '' && tel.trim().length > 60) {
      setErrorMessage('無効なTELです。');
      setOpen(true);
    } else if (chargeTel.trim() !== '' && chargeTel.trim().length > 60) {
      setErrorMessage('無効な顧客側担当者電話番号');
      setOpen(true);
    } else if (
      chargeEmail.trim() != '' &&
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        chargeEmail.trim()
      )
    ) {
      setErrorMessage('顧客側担当者メールアドレスの形式が正しくありません。');
      setOpen(true);
    } else if (
      (selectedDepositeSiteMonth === '' && selectedDepositeSiteDate !== '') ||
      (selectedDepositeSiteMonth !== '' && selectedDepositeSiteDate === '')
    ) {
      setErrorMessage('入金サイト 月を 日付を 必須');
      setOpen(true);
    } else {
      editCustomer(
        history.location.state.state,
        customerName.trim(),
        furigana.trim(),
        postalCode.trim(),
        selectedCustomerType,
        selectedPrefecture,
        municipality.trim(),
        address.trim(),
        buildingName.trim(),
        tel.trim(),
        fax.trim(),
        chargeName.trim(),
        chargeTel.trim(),
        chargeEmail.trim(),
        charge1,
        charge2,
        selectedHousing,
        selectedMediation,
        selectedIndustry,
        selectedEndOfDay,
        selectedDepositeSiteMonth,
        selectedDepositeSiteDate,
        selectedRank,
        remarks.trim()
      ).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              if (charge1Data?.id !== charge1) {
                setCharge1Data(null);
              }
              if (charge2Data?.id !== charge2) {
                setCharge2Data(null);
              }
              setSuccessMessage(data.message);
              setOpenSuccess(true);
            }
          }
        }
      });
    }
  };

  const getAllCustomerDetails = useCallback(() => {
    if (!history.location.state.state) {
      return;
    }
    getCustomerDetails(history.location.state.state).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setCustomerName(data.data.name);
            setFurigana(data.data.furigana);
            setPostalCode(data.data.postal_code);
            if (data.data.prefecture !== '') {
              setSelectedPrefecture(data.data.prefecture);
            }
            if (data.data.client_type !== '') {
              setSelectedCustomerType(data.data.client_type);
            }
            setMunicipality(data.data.muncipality);
            setAddress(data.data.address);
            setBuildingName(data.data.building_name);
            setTel(data.data.tel);
            setFax(data.data.fax);
            setChargeName(data.data.charge_name);
            setChargeTel(data.data.charge_tel);
            setChargeEmail(data.data.charge_email);
            if (data.data.in_charge1 !== '') {
              setCharge1(data.data.in_charge1);
            }
            // 担当者１が無効なユーザーな場合（担当者プルダウン用）
            setCharge1Data(
              data.data.in_charge1_name
                ? { name: data.data.in_charge1_name, id: data.data.in_charge1 }
                : null
            );
            if (data.data.in_charge2 !== '') {
              setCharge2(data.data.in_charge2);
            }
            setCharge2Data(
              data.data.in_charge2_name
                ? { name: data.data.in_charge2_name, id: data.data.in_charge2 }
                : null
            );
            if (data.data.housing !== '') {
              setSelectedHousing(data.data.housing);
            }
            if (data.data.mediation !== '') {
              setSelectedMediation(data.data.mediation);
            }
            if (data.data.industry !== '') {
              setSelectedIndustry(data.data.industry);
            }
            if (data.data.end_day !== '') {
              setSelectedEndOfDay(data.data.end_day);
            }
            if (data.data.deposit_site_month !== '') {
              setSelectedDepositeSiteMonth(data.data.deposit_site_month);
            }
            if (data.data.deposit_site_date !== '') {
              setSelectedDepositeSiteDate(data.data.deposit_site_date);
            }
            if (data.data.rank !== '') {
              setSelectedRank(data.data.rank);
            }
            setRemarks(data.data.remarks);
          }
        }
      }
    });
  }, [changeLoggedInData, history.location.state]);

  const saveContaceUsDetails = () => {
    // if (selectedDateValue.trim() === "") {
    //   setErrorMessage("日付を入力してください。");
    //   setOpen(true);
    // } else if (property.trim() === "") {
    //   setErrorMessage("物件 必須");
    //   setOpen(true);
    // } else if (place.trim() === "") {
    //   setErrorMessage("場所(希望地) 必須");
    //   setOpen(true);
    // } else if (budget <= 0 || isNaN(budget)) {
    //   setErrorMessage("予算 必須");
    //   setOpen(true);
    // } else if (senderEmail.trim() === "") {
    //   setErrorMessage("メールアドレス 必須");
    //   setOpen(true);
    // } else if (!val.test(senderEmail.trim())) {
    //   setErrorMessage("無効なメール");
    //   setOpen(true);
    // } else if (content.trim() === "") {
    //   setErrorMessage("内容 必須");
    //   setOpen(true);
    // } else if (realEstateRequest.trim() === "") {
    //   setErrorMessage("不動産相談希望 必須");
    //   setOpen(true);
    // }
    saveContactUs(
      history.location.state.state,
      content.trim(),
      property.trim(),
      place.trim(),
      realEstateRequest.trim(),
      selectedDate !== null ? selectedDateValue : '',
      budget
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setSuccessMessage(data.message);
            setOpenSuccess(true);
            setContent('');
            setSelectedDateValue('');
            setSelectedDate(null);
            setProperty('');
            setPlace('');
            setRealEstateRequest('');
            setBudget(0);
            getAllContactUsHistory();
          }
        }
      }
    });
  };

  const getAllContactUsHistoryDefault = useCallback(() => {
    if (!history.location.state.state) {
      return;
    }
    getContactUsHistory(history.location.state.state).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setContactHistory(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData, history.location.state]);

  const getAllContactUsHistory = () => {
    getContactUsHistory(history.location.state.state).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setContactHistory(data.data);
          }
        }
      }
    });
  };

  const deleteSelectedCustomer = () => {
    deleteCustomerById(history.location.state.state).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setSuccessMessage(data.message);
            setOpenSuccess(true);
            setTimeout(() => {
              history.goBack();
            }, 1500);
          }
        }
      }
    });
  };

  const getListOfEmployeeGroupListDefault = useCallback(() => {
    getEmployeeGroups().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setEmployeeGroups(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  /**
   * 引き渡し希望日
   */
  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setSelectedDateValue(finaldate);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleClickOpenAlert = () => {
    setOpenAlert(true);
  };
  const getTypes = useCallback(() => {
    getCustomerType().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setAssignedTypes(data.data);
            changeAssignedTypesApiData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData, changeAssignedTypesApiData]);

  useEffect(() => {
    getAllPrefectures();
    getTypes();
    getAllMediation();
    getAllIndustries();
    getAllEndOfDay();
    getAllRanks();
    getInsideEmployees();
    getListOfEmployeeGroupListDefault();
    if (history.location.state) {
      getAllCustomerDetails();
      getAllContactUsHistoryDefault();
      getAllCustomerConstructionDetails();
    }
  }, [
    // eslint-disable-line react-hooks/exhaustive-deps
    getAllPrefectures,
    getAllMediation,
    getAllIndustries,
    getAllEndOfDay,
    getAllRanks,
    getAllCustomerDetails,
    getAllContactUsHistoryDefault,
    history.location.state,
    getAllCustomerConstructionDetails,
    getInsideEmployees,
    getListOfEmployeeGroupListDefault
  ]);

  const deleteSelectedContactUsHistoryById = () => {
    deleteContactUsHistory(selectedContactUsHistoryId).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setOpenAlert(false);
            getAllContactUsHistory();
          }
        }
      }
    });
  };

  const sendMailToGroup = (historyId: number, groupId: number) => {
    sendMail({ historyId, groupId }).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setOpenSuccess(true);
            setSuccessMessage('メールを送信しました。');
            getAllContactUsHistory();
          }
        }
      }
    });
  };

  const handleContactHistoryDeleteButtonClick = (id: number) => {
    setFlag('contactus');
    handleClickOpenAlert();
    setSelectedContactUsHistoryId(id);
  };

  // パンくずリスト用に検索パラメーターを設定
  const patternState: TTopicPathState = {};
  patternState['/customers'] = history.location.state;

  //郵便番号から住所を取得
  const handleAddressFetch = async () => {
    try {
      const result = await fetchAddressFromPostalCode(postalCode);

      if (result.success) {
        const addressData = result.data;

        const matchedPref = (prefecture as any[]).find((p: any) =>
          addressData.prefecture?.includes(p.name)
        );
        if (matchedPref) {
          setSelectedPrefecture(matchedPref.id);
        }

        if (addressData.city) {
          setMunicipality(addressData.city);
        }

        if (addressData.suburb) {
          setAddress(addressData.suburb);
        }

        setErrorMessage('');
      } else {
        setErrorMessage(result.message || '住所の取得に失敗しました');
        setOpen(true);
      }
    } catch (error) {
      setErrorMessage(
        'システムエラーが発生しました。住所は手動で入力してください。'
      );
      setOpen(true);
    }
  };

  // パンくずリスト表示パターン(編集)
  let patternName = 'customers_edit';

  // 新規作成画面のモードの場合
  if (location.pathname.match('create')) {
    // パンくずリスト表示パターン(新規)
    patternName = 'customers_create';
  }

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <>
      <AppBarComponent patternName={patternName} patternState={patternState} />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent isFormGroup={true} />
        </>
      ) : (
        <>
          <div
            style={{
              overflow: 'hidden',
              backgroundColor: '#F5F5F5',
              minHeight: window.innerHeight
            }}
          >
            <div style={{ margin: 15 }}>
              <Snackbar
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
              >
                <Alert onClose={handleClose} severity='error'>
                  {errorMessage}
                </Alert>
              </Snackbar>

              <Snackbar
                open={openSuccess}
                autoHideDuration={4000}
                onClose={handleCloseSuccess}
              >
                <Alert onClose={handleCloseSuccess} severity='success'>
                  {errorMessage}
                </Alert>
              </Snackbar>
            </div>

            <div style={{ backgroundColor: '#FFFFFF' }}>
              <div className={classes.topContainer}>
                <div
                  style={{
                    backgroundColor: '#FFFFFF',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    marginLeft: 15,
                    marginTop: 24
                  }}
                >
                  <div style={{ fontSize: 18 }}>{customerName}</div>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: matches2 ? 'row' : 'column'
                }}
                className={classes.topList}
              >
                <div
                  // 空アイテム
                  className='empty-list'
                  style={{ width: 15 }}
                ></div>
                <div
                  onClick={() => setSelectTab(1)}
                  className='border2'
                  style={{
                    backgroundColor: selectTab == 1 ? '#F5F5F5' : '#ffffff',
                    borderTopColor: selectTab == 1 ? '#0099CB' : '#cccccc',
                    borderBottom: selectTab == 1 ? 'none' : 'solid 1px #cccccc',
                    width: 200
                  }}
                >
                  <div
                    className={classes.topColumn}
                    style={{ color: selectTab == 1 ? '#0099CB' : '#000000' }}
                  >
                    顧客情報
                  </div>
                </div>
                {history.location.state &&
                  defaultValues &&
                  defaultValues.length > 0 && (
                    <div
                      onClick={() => setSelectTab(2)}
                      className='border2'
                      style={{
                        backgroundColor: selectTab == 2 ? '#F5F5F5' : '#ffffff',
                        borderTopColor: selectTab == 2 ? '#0099CB' : '#cccccc',
                        borderBottom:
                          selectTab == 2 ? 'none' : 'solid 1px #cccccc',
                        width: 200
                      }}
                    >
                      <div
                        className={classes.topColumn}
                        style={{
                          color: selectTab == 2 ? '#0099CB' : '#000000'
                        }}
                      >
                        追加情報
                      </div>
                    </div>
                  )}
                <div
                  // 空アイテム
                  className='empty-list'
                  style={{ flexGrow: 1 }}
                ></div>
              </div>
            </div>

            {/** 書類情報の場合 */}
            {selectTab == 1 && (
              <>
                <div style={{ margin: 15 }}>
                  <Dialog
                    open={openAlert}
                    onClose={handleCloseAlert}
                    aria-labelledby='alert-dialog-title'
                    aria-describedby='alert-dialog-description'
                  >
                    <DialogTitle id='alert-dialog-title'>
                      {'削除しますか？'}
                    </DialogTitle>
                    <DialogActions>
                      <Button onClick={handleCloseAlert} color='primary'>
                        キャンセル
                      </Button>
                      <Button
                        onClick={() => {
                          handleCloseAlert();
                          if (flag === 'contactus') {
                            deleteSelectedContactUsHistoryById();
                          } else if (flag === 'customer') {
                            deleteSelectedCustomer();
                          } else {
                          }
                        }}
                        color='primary'
                        autoFocus
                      >
                        削除
                      </Button>
                    </DialogActions>
                  </Dialog>

                  <Snackbar
                    open={open}
                    autoHideDuration={4000}
                    onClose={handleClose}
                  >
                    <Alert onClose={handleClose} severity='error'>
                      {errorMessage}
                    </Alert>
                  </Snackbar>

                  <Snackbar
                    open={openSuccess}
                    autoHideDuration={4000}
                    onClose={handleCloseSuccess}
                  >
                    <Alert onClose={handleCloseSuccess} severity='success'>
                      {successMessage}
                    </Alert>
                  </Snackbar>

                  <div>
                    <div
                      className='table-top-container-customer'
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <div
                        style={{
                          fontWeight: 'bold',
                          padding: 15,
                          paddingBottom: 0,
                          fontSize: 24
                        }}
                      >
                        {'顧客基本情報'}
                      </div>
                      {/* <Button onClick={() => {
                    history.location.state ?
                      editCustomerDetails() :
                      saveCustomerDetails()
                  }} style={{ marginRight: 15, margin: 15, marginBottom: 0, backgroundColor: buttonColor }} variant="contained" color="primary">
                    保存
              </Button> */}
                    </div>

                    <Grid
                      container
                      style={{
                        backgroundColor: '#FFFFFF',
                        paddingBottom: 15,
                        marginBottom: 15
                      }}
                    >
                      <Grid item xs={matches2 ? 4 : 12}>
                        {userMenu != 'Storage' && (
                          <div className={classes.subContainer}>
                            <div className={classes.textMainContainer}>
                              <div className={classes.textContainer}>
                                顧客種別
                              </div>
                            </div>
                            <div className={classes.inputMainContainer}>
                              <div className={classes.inputContainerSelectBox}>
                                <select
                                  value={selectedCustomerType}
                                  onChange={text => {
                                    setSelectedCustomerType(
                                      parseInt(text.target.value)
                                    );
                                  }}
                                  className={classes.selectBoxStyle}
                                  name='cars'
                                  id='cars'
                                  form='carform'
                                >
                                  <option value={0}>選択してください</option>
                                  {assignedTypes.map((i: any) => (
                                    <option value={i.id}>{i.name}</option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        )}
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              顧客名<span>*</span>
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={customerName}
                                placeholder='30文字以内'
                                maxLength={30}
                                onChange={text => {
                                  setCustomerName(text.target.value);
                                }}
                                className={classes.input}
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              ふりがな<span>*</span>
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={furigana}
                                maxLength={80}
                                onChange={text => {
                                  setFurigana(text.target.value);
                                }}
                                className={classes.input}
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              郵便番号
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={postalCode}
                                maxLength={10}
                                onChange={text => {
                                  setPostalCode(text.target.value);
                                }}
                                className={classes.input}
                              />
                            </div>
                            <div>
                              <Button
                                style={{
                                  backgroundColor: buttonColor,
                                  marginRight: 8,
                                  padding: '5px 10px', // ボタン内のテキストに余白を追加
                                  width: 'auto', // ボタンの幅を自動調整
                                  minWidth: '80px' // 最低限の幅を指定（必要に応じて調整）
                                }}
                                variant='contained'
                                color='secondary'
                                onClick={handleAddressFetch}
                              >
                                住所反映
                              </Button>
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              都道府県
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              <select
                                value={selectedPrefecture}
                                onChange={text => {
                                  setSelectedPrefecture(
                                    parseInt(text.target.value)
                                  );
                                }}
                                className={classes.selectBoxStyle}
                                name='cars'
                                id='cars'
                                form='carform'
                              >
                                <option value={0}>選択してください</option>
                                {prefecture.map((i: any) => (
                                  <option value={i.id}>{i.name}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              市区町村
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={municipality}
                                maxLength={60}
                                onChange={text => {
                                  setMunicipality(text.target.value);
                                }}
                                className={classes.input}
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>番地</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={address}
                                maxLength={60}
                                onChange={text => {
                                  setAddress(text.target.value);
                                }}
                                className={classes.input}
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              建物名/部屋番号など
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={buildingName}
                                maxLength={60}
                                onChange={text => {
                                  setBuildingName(text.target.value);
                                }}
                                className={classes.input}
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>TEL</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={tel}
                                maxLength={60}
                                onChange={text => {
                                  setTel(text.target.value);
                                }}
                                className={classes.input}
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>FAX</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={fax}
                                maxLength={60}
                                onChange={text => {
                                  setFax(text.target.value);
                                }}
                                className={classes.input}
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                      </Grid>
                    </Grid>

                    <div
                      className='table-top-container-customer'
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <div
                        style={{
                          fontWeight: 'bold',
                          padding: 15,
                          paddingBottom: 0,
                          fontSize: 24
                        }}
                      >
                        {'担当情報'}
                      </div>
                    </div>
                    <Grid
                      container
                      style={{
                        backgroundColor: '#FFFFFF',
                        marginBottom: 15,
                        paddingBottom: 15
                      }}
                    >
                      <Grid item xs={matches2 ? 4 : 12}>
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              顧客側担当者名
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={chargeName}
                                maxLength={50}
                                onChange={text => {
                                  setChargeName(text.target.value);
                                }}
                                className={classes.input}
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              顧客側担当者電話番号
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={chargeTel}
                                maxLength={60}
                                onChange={text => {
                                  setChargeTel(text.target.value);
                                }}
                                className={classes.input}
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              顧客側担当者メールアドレス
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={chargeEmail}
                                maxLength={50}
                                onChange={text => {
                                  setChargeEmail(text.target.value);
                                }}
                                className={classes.input}
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>担当者1</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              <select
                                value={charge1 === 0 ? '' : charge1}
                                onChange={text => {
                                  setCharge1(parseInt(text.target.value));
                                }}
                                className={classes.selectBoxStyle}
                                name='cars'
                                id='cars'
                                form='carform'
                              >
                                <option value={0}>選択してください</option>
                                {getStaffSelectOptions(
                                  insideEmployees,
                                  charge1Data
                                )}
                              </select>
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>担当者2</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              <select
                                value={charge2 === 0 ? '' : charge2}
                                onChange={text => {
                                  setCharge2(parseInt(text.target.value));
                                }}
                                className={classes.selectBoxStyle}
                                name='cars'
                                id='cars'
                                form='carform'
                              >
                                <option value={0}>選択してください</option>
                                {getStaffSelectOptions(
                                  insideEmployees,
                                  charge2Data
                                )}
                              </select>
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                      </Grid>
                    </Grid>

                    <div
                      className='table-top-container-customer'
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <div
                        style={{
                          fontWeight: 'bold',
                          padding: 15,
                          paddingBottom: 0,
                          fontSize: 24
                        }}
                      >
                        {'業種'}
                      </div>
                    </div>
                    <Grid
                      container
                      style={{
                        backgroundColor: '#FFFFFF',
                        marginBottom: 15,
                        paddingBottom: 15
                      }}
                    >
                      <Grid item xs={matches2 ? 4 : 12}>
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              紹介・媒介
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              <select
                                value={selectedMediation}
                                onChange={text => {
                                  setSelectedMediation(
                                    parseInt(text.target.value)
                                  );
                                }}
                                className={classes.selectBoxStyle}
                                name='cars'
                                id='cars'
                                form='carform'
                              >
                                <option value={0}>選択してください</option>
                                {mediations.map((i: any) => (
                                  <option value={i.id}>{i.name}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>業種</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              <select
                                value={selectedIndustry}
                                onChange={text => {
                                  setSelectedIndustry(
                                    parseInt(text.target.value)
                                  );
                                }}
                                className={classes.selectBoxStyle}
                                name='cars'
                                id='cars'
                                form='carform'
                              >
                                <option value={0}>選択してください</option>
                                {industries.map((i: any) => (
                                  <option value={i.id}>{i.name}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                      </Grid>
                    </Grid>

                    <div
                      className='table-top-container-customer'
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <div
                        style={{
                          fontWeight: 'bold',
                          padding: 15,
                          paddingBottom: 0,
                          fontSize: 24
                        }}
                      >
                        {'取引情報'}
                      </div>
                    </div>
                    <Grid
                      container
                      style={{
                        backgroundColor: '#FFFFFF',
                        marginBottom: 15,
                        paddingBottom: 15
                      }}
                    >
                      <Grid item xs={matches2 ? 4 : 12}>
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>締日</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              <select
                                value={selectedEndOfDay}
                                onChange={text => {
                                  setSelectedEndOfDay(
                                    parseInt(text.target.value)
                                  );
                                }}
                                className={classes.selectBoxStyle}
                                name='cars'
                                id='cars'
                                form='carform'
                              >
                                <option value={0}>選択してください</option>
                                {endOfDay.map((i: any) => (
                                  <option value={i.id}>{i.name}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              入金サイト
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div
                              className={classes.inputContainerSelectBox}
                              style={{ display: 'flex', flexDirection: 'row' }}
                            >
                              <select
                                value={selectedDepositeSiteMonth}
                                onChange={text => {
                                  setSelectedDepositeSiteMonth(
                                    text.target.value
                                  );
                                }}
                                className={classes.selectBoxStyle}
                                name='cars'
                                id='cars'
                                form='carform'
                              >
                                <option value={''}>月を選択</option>
                                <option value={'当月'}>{'当月'}</option>
                                <option value={'翌月'}>{'翌月'}</option>
                                <option value={'翌々月'}>{'翌々月'}</option>
                                <option value={'翌々々月'}>{'翌々々月'}</option>
                              </select>

                              <select
                                style={{ marginLeft: 5 }}
                                value={selectedDepositeSiteDate}
                                onChange={text => {
                                  setSelectedDepositeSiteDate(
                                    text.target.value
                                  );
                                }}
                                className={classes.selectBoxStyle}
                                name='cars'
                                id='cars'
                                form='carform'
                              >
                                <option value={''}>日付を選択</option>
                                <option value={'5'}>5</option>
                                <option value={'10'}>10</option>
                                <option value={'15'}>15</option>
                                <option value={'20'}>20</option>
                                <option value={'25'}>25</option>
                                <option value={'末'}>末</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>ランク</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              <select
                                value={selectedRank}
                                onChange={text => {
                                  setSelectedRank(parseInt(text.target.value));
                                }}
                                className={classes.selectBoxStyle}
                                name='cars'
                                id='cars'
                                form='carform'
                              >
                                <option value={0}>選択してください</option>
                                {rank.map((i: any) => (
                                  <option value={i.id}>{i.name}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                      </Grid>
                    </Grid>

                    <div
                      className='table-top-container-customer'
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <div
                        style={{
                          fontWeight: 'bold',
                          padding: 15,
                          paddingBottom: 0,
                          fontSize: 24
                        }}
                      >
                        {'備考'}
                      </div>
                    </div>
                    <Grid
                      container
                      style={{
                        backgroundColor: '#FFFFFF',
                        marginBottom: 15,
                        paddingBottom: 15
                      }}
                    >
                      <Grid item xs={matches2 ? 5 : 12}>
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer1}>
                            <div className={classes.textContainer1}>備考</div>
                          </div>
                          <div className={classes.inputMainContainer1}>
                            <div className={classes.inputContainer}>
                              <textarea
                                value={remarks}
                                maxLength={225}
                                onChange={text => {
                                  setRemarks(text.target.value);
                                }}
                                className={classes.input1}
                              />
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                      </Grid>
                    </Grid>
                  </div>

                  {history.location.state.state && (
                    <div style={{ backgroundColor: '#FFFFFF' }}>
                      {userMenu != 'Storage' && (
                        <div className='table-top-container-customer'>
                          <div
                            style={{
                              fontWeight: 'bold',
                              padding: 15,
                              paddingBottom: 0,
                              fontSize: 24
                            }}
                          >
                            お問い合わせ
                          </div>
                          <Button
                            style={{
                              marginRight: 15,
                              margin: 15,
                              marginBottom: 0,
                              backgroundColor: buttonColor
                            }}
                            variant='contained'
                            color='primary'
                            onClick={() => saveContaceUsDetails()}
                          >
                            保存
                          </Button>
                        </div>
                      )}

                      {userMenu != 'Storage' && (
                        <Grid container>
                          <Grid item xs={matches2 ? 4 : 12}>
                            <DateField
                              text={'引き渡し希望日'}
                              date={selectedDate}
                              onChange={handleDateChange}
                              id='date-picker-inline'
                              emptyLabel='日付を選択'
                            />

                            <div className={classes.subContainer}>
                              <div className={classes.textMainContainer}>
                                <div className={classes.textContainer}>
                                  物件
                                </div>
                              </div>
                              <div className={classes.inputMainContainer}>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center'
                                  }}
                                >
                                  <div
                                    onClick={() => setProperty('取得済')}
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                      padding: 8
                                    }}
                                  >
                                    <div className='checkbox'>
                                      {property === '取得済' && (
                                        <div className='dot' />
                                      )}
                                    </div>
                                    <div
                                      style={{ fontSize: 16, marginLeft: 5 }}
                                    >
                                      {'取得済'}
                                    </div>
                                  </div>

                                  <div
                                    onClick={() => setProperty('なし')}
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                      padding: 8
                                    }}
                                  >
                                    <div className='checkbox'>
                                      {property === 'なし' && (
                                        <div className='dot' />
                                      )}
                                    </div>
                                    <div
                                      style={{ fontSize: 16, marginLeft: 5 }}
                                    >
                                      {'なし'}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <Divider
                              style={{
                                backgroundColor: '#CCCCCC',
                                marginLeft: 15
                              }}
                            />
                            <div className={classes.subContainer}>
                              <div className={classes.textMainContainer}>
                                <div className={classes.textContainer}>
                                  場所(希望地)
                                </div>
                              </div>
                              <div className={classes.inputMainContainer}>
                                <div className={classes.inputContainer}>
                                  <input
                                    value={place}
                                    maxLength={30}
                                    placeholder='30文字以内'
                                    onChange={text => {
                                      setPlace(text.target.value);
                                    }}
                                    className={classes.input}
                                  />
                                </div>
                              </div>
                            </div>

                            <Divider
                              style={{
                                backgroundColor: '#CCCCCC',
                                marginLeft: 15
                              }}
                            />
                            <div className={classes.subContainer}>
                              <div className={classes.textMainContainer}>
                                <div className={classes.textContainer}>
                                  予算
                                </div>
                              </div>
                              <div className={classes.inputMainContainer}>
                                <div className={classes.inputContainer}>
                                  <NumberInput
                                    symbol=''
                                    value={budget === 0 ? '' : budget}
                                    maxLength={10}
                                    onChange={(
                                      e: React.ChangeEvent<HTMLInputElement>
                                    ) => {
                                      setBudget(parseInt(e.target.value));
                                    }}
                                    className={classes.input}
                                  />
                                </div>
                              </div>
                            </div>
                            <Divider
                              style={{
                                backgroundColor: '#CCCCCC',
                                marginLeft: 15
                              }}
                            />
                          </Grid>

                          <Grid item xs={matches2 ? 8 : 12}>
                            <div className={classes.subContainer}>
                              <div
                                style={{ width: matches2 ? '20%' : '50%' }}
                                className={classes.textMainContainer2}
                              >
                                <div className={classes.textContainer1}>
                                  内容
                                </div>
                              </div>
                              <div className={classes.inputMainContainer1}>
                                <div className={classes.inputContainer}>
                                  <textarea
                                    value={content}
                                    maxLength={1000}
                                    placeholder='1000文字以内'
                                    onChange={text => {
                                      setContent(text.target.value);
                                    }}
                                    className={classes.input1}
                                  />
                                </div>
                              </div>
                            </div>
                            <Divider
                              style={{
                                backgroundColor: '#CCCCCC',
                                marginLeft: 15
                              }}
                            />

                            <div className={classes.subContainer}>
                              <div
                                style={{ width: matches2 ? '20%' : '50%' }}
                                className={classes.textMainContainer2}
                              >
                                <div className={classes.textContainer1}>
                                  不動産相談希望
                                </div>
                              </div>
                              <div className={classes.inputMainContainer1}>
                                <div className={classes.inputContainer}>
                                  <textarea
                                    value={realEstateRequest}
                                    maxLength={1000}
                                    placeholder='1000文字以内'
                                    onChange={text => {
                                      setRealEstateRequest(text.target.value);
                                    }}
                                    className={classes.input1}
                                  />
                                </div>
                              </div>
                            </div>
                            <Divider
                              style={{
                                backgroundColor: '#CCCCCC',
                                marginLeft: 15
                              }}
                            />
                          </Grid>
                        </Grid>
                      )}

                      {userMenu != 'Storage' && (
                        <div
                          style={{ marginTop: 25 }}
                          className='table-top-container-customer'
                        >
                          <div
                            style={{
                              fontWeight: 'bold',
                              padding: 15,
                              paddingBottom: 0,
                              fontSize: 24
                            }}
                          >
                            お問い合わせ履歴
                          </div>
                        </div>
                      )}
                      {userMenu != 'Storage' && (
                        <div
                          style={{
                            marginLeft: 15,
                            marginRight: 15,
                            paddingBottom: 15
                          }}
                        >
                          <TableContainer component={Paper}>
                            <Table
                              className={classes.table1}
                              aria-label='customized table'
                            >
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell
                                    style={{ minWidth: 90 }}
                                    className={classes.table}
                                    align='center'
                                  >
                                    引渡し希望日
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{ minWidth: 80 }}
                                    className={classes.table}
                                    align='center'
                                  >
                                    物件
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{ minWidth: 90 }}
                                    className={classes.table}
                                    align='center'
                                  >
                                    場所(希望地)
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{ minWidth: 80 }}
                                    className={classes.table}
                                    align='center'
                                  >
                                    予算
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{ minWidth: 150 }}
                                    className={classes.table}
                                    align='center'
                                  >
                                    内容
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{ minWidth: 150 }}
                                    className={classes.table}
                                    align='center'
                                  >
                                    不動産相談希望
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{ minWidth: 150 }}
                                    className={classes.table}
                                    align='center'
                                  >
                                    宛先グループ
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{ minWidth: 100 }}
                                    className={classes.table}
                                    align='center'
                                  ></StyledTableCell>
                                  <StyledTableCell
                                    style={{ minWidth: 100 }}
                                    className={classes.table}
                                    align='center'
                                  ></StyledTableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {contactHistory.map((row: any) => (
                                  <ContactHistoryTableRow
                                    row={row}
                                    employeeGroups={employeeGroups}
                                    handleContactHistoryDeleteButtonClick={
                                      handleContactHistoryDeleteButtonClick
                                    }
                                    sendMailToGroup={sendMailToGroup}
                                  />
                                ))}
                              </TableBody>
                            </Table>
                            {contactHistory.length === 0 && (
                              <div className={classes.container}>
                                データがありません
                              </div>
                            )}
                          </TableContainer>
                        </div>
                      )}
                      <div style={{ height: 15, backgroundColor: '#F5F5F5' }} />

                      <div className='table-top-container-customer'>
                        <div
                          style={{
                            fontWeight: 'bold',
                            padding: 15,
                            paddingBottom: 0,
                            fontSize: 24
                          }}
                        >
                          工事履歴
                        </div>
                      </div>

                      <div
                        style={{
                          marginLeft: 15,
                          marginRight: 15,
                          paddingBottom: 5
                        }}
                      >
                        <TableContainer component={Paper}>
                          <Table
                            className={classes.table1}
                            aria-label='customized table'
                          >
                            <TableHead>
                              <TableRow>
                                {userMenu != 'Storage' && (
                                  <>
                                    <StyledTableCell
                                      style={{ minWidth: 80 }}
                                      className={classes.table}
                                      align='center'
                                    >
                                      進行状況
                                    </StyledTableCell>
                                  </>
                                )}
                                <StyledTableCell
                                  style={{ minWidth: 80 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  担当者名
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 80 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  工事件名
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 80 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  案件種別
                                </StyledTableCell>
                                <StyledTableCell
                                  style={{ minWidth: 80 }}
                                  className={classes.table}
                                  align='center'
                                >
                                  顧客名
                                </StyledTableCell>
                                {userMenu != 'Storage' && (
                                  <>
                                    <StyledTableCell
                                      style={{ minWidth: 80 }}
                                      className={classes.table}
                                      align='center'
                                    >
                                      契約予定日
                                    </StyledTableCell>
                                    <StyledTableCell
                                      style={{ minWidth: 80 }}
                                      className={classes.table}
                                      align='center'
                                    >
                                      契約日
                                    </StyledTableCell>
                                    <StyledTableCell
                                      style={{ minWidth: 80 }}
                                      className={classes.table}
                                      align='center'
                                    >
                                      着工予定日
                                    </StyledTableCell>
                                    <StyledTableCell
                                      style={{ minWidth: 80 }}
                                      className={classes.table}
                                      align='center'
                                    >
                                      着工日
                                    </StyledTableCell>
                                    <StyledTableCell
                                      style={{ minWidth: 110 }}
                                      className={classes.table}
                                      align='center'
                                    >
                                      竣工予定日
                                    </StyledTableCell>
                                    <StyledTableCell
                                      style={{ minWidth: 80 }}
                                      className={classes.table}
                                      align='center'
                                    >
                                      竣工日
                                    </StyledTableCell>
                                    <StyledTableCell
                                      style={{ minWidth: 100 }}
                                      className={classes.table}
                                      align='center'
                                    >
                                      請求日
                                    </StyledTableCell>
                                    <StyledTableCell
                                      style={{ minWidth: 80 }}
                                      className={classes.table}
                                      align='center'
                                    >
                                      完工入金日
                                    </StyledTableCell>
                                    <StyledTableCell
                                      style={{ minWidth: 90 }}
                                      className={classes.table}
                                      align='center'
                                    >
                                      計画原価
                                    </StyledTableCell>
                                    <StyledTableCell
                                      style={{ minWidth: 90 }}
                                      className={classes.table}
                                      align='center'
                                    >
                                      計画粗利率
                                    </StyledTableCell>
                                  </>
                                )}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {customerConstructionData.map(
                                (row: any, index: number) => (
                                  <StyledTableRow className='click_table_row'>
                                    {userMenu != 'Storage' && (
                                      <>
                                        <StyledTableCell
                                          onClick={() => {
                                            history.push(
                                              `/constructions/${row.id}/edit`,
                                              { state: row.id }
                                            );
                                          }}
                                          className={classes.table1}
                                          style={{ minWidth: 90 }}
                                          align='center'
                                        >
                                          {row.progress}
                                        </StyledTableCell>
                                      </>
                                    )}
                                    <StyledTableCell
                                      onClick={() => {
                                        history.push(
                                          `/constructions/${row.id}/edit`,
                                          { state: row.id }
                                        );
                                      }}
                                      className={classes.table1}
                                      style={{ minWidth: 80 }}
                                      align='center'
                                    >
                                      {row.assignee_user}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      onClick={() => {
                                        history.push(
                                          `/constructions/${row.id}/edit`,
                                          { state: row.id }
                                        );
                                      }}
                                      className={classes.table1}
                                      style={{ minWidth: 120 }}
                                      align='center'
                                    >
                                      {row.name}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      onClick={() => {
                                        history.push(
                                          `/constructions/${row.id}/edit`,
                                          { state: row.id }
                                        );
                                      }}
                                      className={classes.table1}
                                      style={{ minWidth: 80 }}
                                      align='center'
                                    >
                                      {row.construct_type}
                                    </StyledTableCell>
                                    <StyledTableCell
                                      onClick={() => {
                                        history.push(
                                          `/constructions/${row.id}/edit`,
                                          { state: row.id }
                                        );
                                      }}
                                      className={classes.table1}
                                      style={{ minWidth: 80 }}
                                      align='center'
                                    >
                                      {row.customer_name}
                                    </StyledTableCell>
                                    {userMenu != 'Storage' && (
                                      <>
                                        <StyledTableCell
                                          onClick={() => {
                                            history.push(
                                              `/constructions/${row.id}/edit`,
                                              { state: row.id }
                                            );
                                          }}
                                          className={classes.table1}
                                          style={{ minWidth: 80 }}
                                          align='center'
                                        >
                                          {row.expected_contract_date}
                                        </StyledTableCell>
                                        <StyledTableCell
                                          onClick={() => {
                                            history.push(
                                              `/constructions/${row.id}/edit`,
                                              { state: row.id }
                                            );
                                          }}
                                          className={classes.table1}
                                          style={{ minWidth: 80 }}
                                          align='center'
                                        >
                                          {row.contract_date}
                                        </StyledTableCell>
                                        <StyledTableCell
                                          onClick={() => {
                                            history.push(
                                              `/constructions/${row.id}/edit`,
                                              { state: row.id }
                                            );
                                          }}
                                          className={classes.table1}
                                          style={{ minWidth: 80 }}
                                          align='center'
                                        >
                                          {row.expected_start_date}
                                        </StyledTableCell>
                                        <StyledTableCell
                                          onClick={() => {
                                            history.push(
                                              `/constructions/${row.id}/edit`,
                                              { state: row.id }
                                            );
                                          }}
                                          className={classes.table1}
                                          style={{ minWidth: 80 }}
                                          align='center'
                                        >
                                          {row.start_date}
                                        </StyledTableCell>
                                        <StyledTableCell
                                          onClick={() => {
                                            history.push(
                                              `/constructions/${row.id}/edit`,
                                              { state: row.id }
                                            );
                                          }}
                                          className={classes.table1}
                                          style={{ minWidth: 80 }}
                                          align='center'
                                        >
                                          {row.expected_end_date}
                                        </StyledTableCell>
                                        <StyledTableCell
                                          onClick={() => {
                                            history.push(
                                              `/constructions/${row.id}/edit`,
                                              { state: row.id }
                                            );
                                          }}
                                          className={classes.table1}
                                          style={{ minWidth: 80 }}
                                          align='center'
                                        >
                                          {row.end_date}
                                        </StyledTableCell>
                                        <StyledTableCell
                                          onClick={() => {
                                            history.push(
                                              `/constructions/${row.id}/edit`,
                                              { state: row.id }
                                            );
                                          }}
                                          className={classes.table1}
                                          style={{ minWidth: 80 }}
                                          align='center'
                                        >
                                          {row.billing_date}
                                        </StyledTableCell>
                                        <StyledTableCell
                                          onClick={() => {
                                            history.push(
                                              `/constructions/${row.id}/edit`,
                                              { state: row.id }
                                            );
                                          }}
                                          className={classes.table1}
                                          style={{ minWidth: 80 }}
                                          align='center'
                                        >
                                          {row.payment_date}
                                        </StyledTableCell>
                                        <StyledTableCell
                                          onClick={() => {
                                            history.push(
                                              `/constructions/${row.id}/edit`,
                                              { state: row.id }
                                            );
                                          }}
                                          className={classes.table1}
                                          style={{ minWidth: 80 }}
                                          align='center'
                                        >
                                          {row.planned_cost}
                                        </StyledTableCell>
                                        <StyledTableCell
                                          onClick={() => {
                                            history.push(
                                              `/constructions/${row.id}/edit`,
                                              { state: row.id }
                                            );
                                          }}
                                          className={classes.table1}
                                          style={{ minWidth: 80 }}
                                          align='center'
                                        >
                                          {row.planned_gross_profit}
                                        </StyledTableCell>
                                      </>
                                    )}
                                  </StyledTableRow>
                                )
                              )}
                            </TableBody>
                          </Table>

                          {customerConstructionData.length === 0 && (
                            <div className={classes.container}>
                              データがありません
                            </div>
                          )}
                        </TableContainer>
                      </div>

                      <div
                        style={{ height: 10, backgroundColor: '#FFFFFF' }}
                      ></div>
                    </div>
                  )}
                </div>
                <div style={{ height: 80 }} />
                <div
                  className='save-btn-container'
                  style={{
                    backgroundColor: '#FFFFFF',
                    position: 'fixed',
                    bottom: 0,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-around',
                    padding: 20
                  }}
                >
                  {isMobile ? <></> : <div style={{ flex: 1 }} />}
                  <div
                    style={{
                      flex: 1,
                      textAlign: 'center'
                    }}
                  >
                    <Button
                      onClick={() => {
                        history.location.state.state
                          ? editCustomerDetails()
                          : saveCustomerDetails();
                      }}
                      style={{
                        paddingLeft: isMobile ? 10 : 50,
                        paddingRight: isMobile ? 10 : 50,
                        backgroundColor: buttonColor
                      }}
                      variant='contained'
                      color='primary'
                    >
                      保存
                    </Button>
                  </div>
                  <div
                    style={{
                      flex: 1,
                      textAlign: 'right',
                      paddingRight: isMobile ? 0 : 20
                    }}
                  >
                    {history.location.state.state && (
                      <div>
                        {isMobile ? (
                          <div style={{ display: 'flex' }}>
                            <Button
                              style={{
                                backgroundColor: buttonColor,
                                marginRight: 5,
                                marginBottom: !matches2 ? 10 : 0
                              }}
                              variant='contained'
                              color='secondary'
                              onClick={() =>
                                history.push('/constructions/create', {
                                  state: history.location.state.state,
                                  params: history.location.state.params
                                })
                              }
                            >
                              <NoteAddIcon />
                            </Button>
                            <Button
                              style={{
                                marginRight: 5,
                                color: '#758283',
                                backgroundColor: '#F5F5F5',
                                marginBottom: !matches2 ? 10 : 0
                              }}
                              variant='contained'
                              color='secondary'
                              onClick={() => {
                                setFlag('customer');
                                handleClickOpenAlert();
                              }}
                            >
                              <DeleteIcon />
                            </Button>
                          </div>
                        ) : (
                          <>
                            {isCustomerSpecificInvoiceAvailable && (
                              <CustomTooltip
                                title={
                                  tooltipContents.CreateCustomerSpecificInvoice
                                }
                              >
                                <Button
                                  style={{
                                    backgroundColor: buttonColor,
                                    marginRight: 30,
                                    marginBottom: !matches2 ? 10 : 0
                                  }}
                                  variant='contained'
                                  color='secondary'
                                  startIcon={<NoteAddIcon />}
                                  onClick={() => {
                                    history.push('/invoices/create', {
                                      state: history.location.state,
                                      params: history.location.state.params,
                                      source: 'customer',
                                      clientId: history.location.state.state,
                                      clientname: customerName,
                                      selectedDepositeSiteMonth:
                                        selectedDepositeSiteMonth,
                                      selectedDepositeSiteDate:
                                        selectedDepositeSiteDate,
                                      endOfDay: endOfDay,
                                      selectedEndofDay: selectedEndOfDay,
                                      salesUserId: charge1
                                    });
                                  }}
                                >
                                  新規顧客別請求書作成
                                </Button>
                              </CustomTooltip>
                            )}
                            <Button
                              style={{
                                backgroundColor: buttonColor,
                                marginRight: 10,
                                marginBottom: !matches2 ? 10 : 0
                              }}
                              variant='contained'
                              color='secondary'
                              startIcon={<NoteAddIcon />}
                              onClick={() =>
                                history.push('/constructions/create', {
                                  state: history.location.state.state,
                                  params: history.location.state.params
                                })
                              }
                            >
                              新規工事作成
                            </Button>

                            <Button
                              style={{
                                marginRight: 10,
                                color: '#758283',
                                backgroundColor: '#F5F5F5',
                                marginBottom: !matches2 ? 10 : 0
                              }}
                              variant='contained'
                              color='secondary'
                              onClick={() => {
                                setFlag('customer');
                                handleClickOpenAlert();
                              }}
                              startIcon={<DeleteIcon />}
                            >
                              削除
                            </Button>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}

            {/** 追加情報の場合 */}
            {history.location.state &&
              selectTab == 2 &&
              defaultValues &&
              defaultValues.length > 0 && (
                <>
                  <ExtInfoBoxes
                    defaultValues={defaultValues}
                    targetId={history.location.state.state}
                    ext_info_screen_type={EXT_INFO_SCREEN_TYPE.CLIENT}
                    setOpen={setOpen}
                    setOpenSuccess={setOpenSuccess}
                    setErrorMessage={setErrorMessage}
                    getData={getData}
                  />
                  <div style={{ height: 80 }} />
                </>
              )}
          </div>
        </>
      )}
    </>
  );
};
